(function () {
  const storageKey = 'duneWishlist';

  function installMobileDrawerFix() {
    if (document.getElementById('dune-mobile-drawer-fix')) return;

    const style = document.createElement('style');
    style.id = 'dune-mobile-drawer-fix';
    style.textContent = `
      @media screen and (max-width: 749px) {
        .js .menu-drawer {
          box-sizing: border-box !important;
          height: calc(var(--viewport-height, 100vh) - var(--header-bottom-position, 0)) !important;
          left: 0 !important;
          max-width: none !important;
          position: fixed !important;
          right: 0 !important;
          top: var(--header-bottom-position, 0) !important;
          width: 100vw !important;
          z-index: 30 !important;
        }

        summary.header__icon.header__icon--menu[aria-expanded='true']::before {
          background: rgba(0, 0, 0, 0.14) !important;
          content: '' !important;
          display: block !important;
          height: auto !important;
          inset: var(--header-bottom-position, 0) 0 0 0 !important;
          opacity: 1 !important;
          position: fixed !important;
          visibility: visible !important;
          width: auto !important;
          z-index: 19 !important;
        }
      }
    `;
    document.head.appendChild(style);
  }

  function readWishlist() {
    try {
      return JSON.parse(window.localStorage.getItem(storageKey)) || [];
    } catch (error) {
      return [];
    }
  }

  function writeWishlist(items) {
    window.localStorage.setItem(storageKey, JSON.stringify(items));
  }

  function findItem(items, handle) {
    return items.find((item) => item.handle === handle);
  }

  function closePopover() {
    document.querySelectorAll('.dune-wishlist-popover').forEach((popover) => popover.remove());
  }

  function renderPopover(anchor) {
    const items = readWishlist();
    closePopover();

    const popover = document.createElement('div');
    popover.className = 'dune-wishlist-popover';
    popover.setAttribute('role', 'dialog');
    popover.setAttribute('aria-label', 'Wishlist');

    if (items.length) {
      const list = document.createElement('ul');
      list.className = 'dune-wishlist-popover__list';
      items.slice(0, 6).forEach((item) => {
        const row = document.createElement('li');
        const link = document.createElement('a');
        link.href = item.url || `/products/${item.handle}`;
        link.textContent = item.title || item.handle;
        row.appendChild(link);
        const removeButton = document.createElement('button');
        removeButton.type = 'button';
        removeButton.textContent = 'Remove';
        removeButton.setAttribute('data-dune-wishlist-remove', item.handle);
        removeButton.setAttribute('aria-label', `Remove ${item.title || item.handle} from wishlist`);
        row.appendChild(removeButton);
        list.appendChild(row);
      });
      popover.appendChild(list);
    } else {
      const empty = document.createElement('p');
      empty.className = 'dune-wishlist-popover__empty';
      empty.textContent = 'Your saved pieces will appear here.';
      popover.appendChild(empty);
    }

    const rect = anchor.getBoundingClientRect();
    popover.style.top = `${rect.bottom + window.scrollY + 10}px`;
    popover.style.right = `${Math.max(16, window.innerWidth - rect.right)}px`;
    document.body.appendChild(popover);
  }

  function syncButtons() {
    const items = readWishlist();
    document.querySelectorAll('[data-dune-wishlist-toggle]').forEach((button) => {
      const handle = button.getAttribute('data-product-handle');
      const selected = Boolean(findItem(items, handle));
      button.classList.toggle('is-active', selected);
      button.setAttribute('aria-pressed', selected ? 'true' : 'false');
      button.setAttribute('aria-label', selected ? 'Remove from wishlist' : 'Add to wishlist');
    });

    document.querySelectorAll('[data-dune-wishlist-header]').forEach((button) => {
      const count = button.querySelector('.dune-wishlist-count');
      button.classList.toggle('is-active', items.length > 0);
      if (count) {
        count.textContent = items.length ? String(items.length) : '';
        count.hidden = items.length === 0;
      }
    });
  }

  document.addEventListener('click', (event) => {
    const removeButton = event.target.closest('[data-dune-wishlist-remove]');
    if (removeButton) {
      event.preventDefault();
      event.stopPropagation();
      const handle = removeButton.getAttribute('data-dune-wishlist-remove');
      writeWishlist(readWishlist().filter((item) => item.handle !== handle));
      syncButtons();
      const headerButton = document.querySelector('[data-dune-wishlist-header]');
      if (headerButton) {
        renderPopover(headerButton);
      } else {
        closePopover();
      }
      return;
    }

    const headerButton = event.target.closest('[data-dune-wishlist-header]');
    if (headerButton) {
      event.preventDefault();
      event.stopPropagation();
      renderPopover(headerButton);
      return;
    }

    const button = event.target.closest('[data-dune-wishlist-toggle]');
    if (!button) {
      closePopover();
      return;
    }

    event.preventDefault();
    event.stopPropagation();

    const handle = button.getAttribute('data-product-handle');
    if (!handle) return;

    const items = readWishlist();
    const existing = findItem(items, handle);

    if (existing) {
      writeWishlist(items.filter((item) => item.handle !== handle));
    } else {
      items.push({
        handle,
        id: button.getAttribute('data-product-id') || '',
        title: button.getAttribute('data-product-title') || '',
        url: button.getAttribute('data-product-url') || '',
      });
      writeWishlist(items);
    }

    syncButtons();
  });

  document.addEventListener('pointerdown', (event) => {
    const wrapper = event.target.closest('.card-wrapper');
    if (!wrapper || event.target.closest('[data-dune-wishlist-toggle]')) return;
    wrapper.classList.add('dune-card-secondary-active');
    window.clearTimeout(wrapper.duneSecondaryTimer);
    wrapper.duneSecondaryTimer = window.setTimeout(() => {
      wrapper.classList.remove('dune-card-secondary-active');
    }, 1400);
  }, { passive: true });

  installMobileDrawerFix();
  document.addEventListener('DOMContentLoaded', () => {
    installMobileDrawerFix();
    syncButtons();
  });
  document.addEventListener('shopify:section:load', () => {
    installMobileDrawerFix();
    syncButtons();
  });
})();
